module.exports = __webpack_public_path__ + "img/vacance2.68062835.jpg";